import React from "react";
import classes from "./ClientsGraph.module.scss";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface Props {
  opened: any;
  inProcess: any;

  pendingClientsCount: number;
  approvedClientsCount: number;
}

const ClientsGraph = ({
  opened,
  inProcess,
  pendingClientsCount,
  approvedClientsCount,
}: Props) => {
  const percentage = opened !== "NaN" ? opened : 0;

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.title}>
          Clients({approvedClientsCount + pendingClientsCount})
        </div>

        <div style={{ width: "45%", height: "100%", margin: "0 1.4rem" }}>
          <CircularProgressbar
            value={opened}
            text={`${percentage}%`}
            strokeWidth={14}
            styles={buildStyles({
              textSize: "14px",

              pathTransitionDuration: 0.5,
              pathColor: `rgba(0, 103, 121, 1)`,
              textColor: "rgba(0, 103, 121, 1)",
              trailColor: "rgba(158, 204, 209, 1)",
              backgroundColor: "#3e98c7",
            })}
          />
        </div>
        <div
          style={{
            display: "flex",
            // justifyContent: "space-between",
            justifyItems: "center",
            justifyContent: "center",
            padding: "1rem 1rem",
            width: "100%",
          }}
        >
          <div className={classes.legend}>
            <div className={classes.legendHeading}>
              <div
                className={classes.legendDot}
                style={{ background: "rgba(0, 103, 121, 1)" }}
              ></div>
              <div className={classes.legendName}>Approved Clients</div>
            </div>
            <div className={classes.legendData}>{approvedClientsCount}</div>
          </div>
          <div className={classes.legend}>
            <div className={classes.legendHeading}>
              <div
                className={classes.legendDot}
                style={{ background: "rgba(158, 204, 209, 1)" }}
              ></div>
              <div className={classes.legendName}>Pending Clients</div>
            </div>
            <div className={classes.legendData}>{pendingClientsCount}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientsGraph;
